import React from 'react';
import { Check } from 'lucide-react';

const defaultSteps = [
  { label: 'Servicios', number: 1 },
  { label: 'Fecha y Hora', number: 2 },
  { label: 'Verificacion', number: 3 },
  { label: 'Confirmacion', number: 4 },
];

const StepProgress = ({ currentStep, steps = defaultSteps }) => {
  return (
    <>
      {/* Inline responsive styles */}
      <style>{`
        .step-progress-bar { gap: 0; }
        .step-progress-bar .step-connector {
          height: 2px;
          width: 50px;
          margin-bottom: 18px;
          border-radius: 1px;
        }
        .step-progress-bar .step-circle {
          width: 32px;
          height: 32px;
          font-size: 0.85rem;
        }
        .step-progress-bar .step-label {
          font-size: 0.7rem;
        }
        @media (max-width: 575.98px) {
          .step-progress-bar .step-connector {
            width: 24px;
            margin-bottom: 14px;
          }
          .step-progress-bar .step-circle {
            width: 26px;
            height: 26px;
            font-size: 0.7rem;
          }
          .step-progress-bar .step-label {
            font-size: 0.58rem;
          }
        }
      `}</style>

      <div className="step-progress-bar d-flex align-items-center justify-content-center mb-4">
        {steps.map((step, idx) => {
          const isCompleted = currentStep > step.number;
          const isCurrent = currentStep === step.number;

          return (
            <React.Fragment key={step.number}>
              <div className="d-flex flex-column align-items-center gap-1">
                <div
                  className="step-circle rounded-circle d-flex align-items-center justify-content-center fw-medium"
                  style={{
                    background: isCompleted || isCurrent
                      ? 'linear-gradient(135deg, #EF60A3 0%, #F49BC3 100%)'
                      : '#FCE4EC',
                    color: isCompleted || isCurrent ? '#fff' : '#C48BA0',
                    boxShadow: isCurrent ? '0 0 0 4px rgba(239,96,163,0.2)' : 'none',
                  }}
                >
                  {isCompleted ? <Check size={14} /> : step.number}
                </div>
                <span
                  className="step-label text-nowrap"
                  style={{
                    fontWeight: isCurrent ? 600 : 400,
                    color: isCurrent || isCompleted ? '#EF60A3' : '#C48BA0',
                  }}
                >
                  {step.label}
                </span>
              </div>

              {idx < steps.length - 1 && (
                <div
                  className="step-connector mx-1 mx-sm-2"
                  style={{
                    background: currentStep > step.number
                      ? 'linear-gradient(90deg, #EF60A3, #F49BC3)'
                      : '#FCE4EC',
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
};

export default StepProgress;
